export default __webpack_public_path__ + "static/media/thankyou.4a2a867d.jpg";